import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=66484f24&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=ts"
export * from "./Btn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66484f24",
  null
  
)

export default component.exports